module.exports = __webpack_public_path__ + "img/27.d161f6c0.jpg";